var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Input } from 'reactstrap';
import axios from 'axios';
var defaultCoords = { lat: 36.7213, lng: -4.4217 }; // Málaga por defecto
export var LocationPicker = function (_a) {
    var initialValue = _a.initialValue, onChange = _a.onChange;
    var mapRef = useRef(null);
    var markerRef = useRef(null);
    var _b = useState(null), mapInstance = _b[0], setMapInstance = _b[1];
    var _c = useState(''), search = _c[0], setSearch = _c[1];
    var _d = useState(initialValue || null), location = _d[0], setLocation = _d[1];
    useEffect(function () {
        if (mapRef.current && !mapInstance) {
            var map_1 = L.map(mapRef.current).setView(initialValue ? [initialValue.lat, initialValue.lng] : [defaultCoords.lat, defaultCoords.lng], 13);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap contributors'
            }).addTo(map_1);
            map_1.on('click', function (e) {
                setMarker(map_1, e.latlng.lat, e.latlng.lng);
                reverseGeocode(e.latlng.lat, e.latlng.lng);
            });
            setMapInstance(map_1);
            if (initialValue) {
                setMarker(map_1, initialValue.lat, initialValue.lng);
            }
        }
    }, [mapRef, mapInstance]);
    var setMarker = function (map, lat, lng) {
        if (markerRef.current) {
            markerRef.current.setLatLng([lat, lng]);
        }
        else {
            var marker = L.marker([lat, lng]).addTo(map);
            markerRef.current = marker;
        }
    };
    var reverseGeocode = function (lat, lng) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, address, result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("https://nominatim.openstreetmap.org/reverse", {
                            params: {
                                format: 'json',
                                lat: lat,
                                lon: lng,
                                addressdetails: 1,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    data = response.data;
                    address = data.address || {};
                    result = {
                        lat: lat,
                        lng: lng,
                        displayName: data.display_name,
                        street: address.road || '',
                        city: address.city || address.town || address.village || '',
                        postalCode: address.postcode || '',
                        country: address.country || '',
                        full: address
                    };
                    setLocation(result);
                    onChange(result);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.error('Error geocoding', err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var searchAddress = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, lat, lng, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("https://nominatim.openstreetmap.org/search", {
                            params: {
                                format: 'json',
                                q: search,
                                addressdetails: 1,
                                limit: 1
                            }
                        })];
                case 1:
                    response = _a.sent();
                    result = response.data[0];
                    if (result && mapInstance) {
                        lat = parseFloat(result.lat);
                        lng = parseFloat(result.lon);
                        mapInstance.setView([lat, lng], 15);
                        setMarker(mapInstance, lat, lng);
                        reverseGeocode(lat, lng);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.error('Error searching address', err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", null,
        React.createElement(Input, { type: "text", value: search, onChange: function (e) { return setSearch(e.target.value); }, placeholder: "Buscar direcci\u00F3n", onKeyDown: function (e) { return e.key === 'Enter' && searchAddress(); }, className: "mb-2" }),
        React.createElement("div", { ref: mapRef, style: { height: '400px', width: '100%' } }),
        location && (React.createElement("div", { className: "mt-2" },
            React.createElement("strong", null, "Direcci\u00F3n seleccionada:"),
            React.createElement("div", null, location.displayName),
            React.createElement("div", null,
                React.createElement("small", null,
                    location.city,
                    ", ",
                    location.country))))));
};
export default LocationPicker;



//////////////////
// WEBPACK FOOTER
// ./src/components/LocationPicker/AdvancedLocationPicker/LocationPicker.tsx
// module id = 1537
// module chunks = 0